import React, { Fragment, useRef, useState } from 'react';

import { useTopic } from '@pkg/components';
import { glShowUIButtons } from '@pkg/components/Sections/Profile/pubSub/constants';
import { useAppSelector } from '@pkg/hooks';
import { useGetPortfolioLidTokensData } from '@pkg/hooks/liquid-id';
import { FACE_NAMES } from '@pkg/webgl/shared';

import { LIQUID_ID_FACES_LENGTH } from '../config';

import Thumbnail from './Thumbnail';

import { LiquidIDThumbnailsWrapper, OuterThumbnailWrapper, ThumbnailsList, ThumbnailWrapper } from './styles';

const LIQUID_ID_THUMBNAIL_WRAPPER_CLASS_NAME = 'liquid-id-draggable-thumbnail';
const formatId = (id: string) => `${LIQUID_ID_THUMBNAIL_WRAPPER_CLASS_NAME}-${id}`;

interface Props {
    removeFace?: (face: number) => void;
    onClick?: (index: number) => void;
    liquidIDFaceSelection?: number;
    className?: string;
}

const LiquidIDThumbnails = ({ className, onClick, liquidIDFaceSelection, removeFace }: Props) => {
    const { data: liquidIDItems } = useGetPortfolioLidTokensData();
    const editingLiquidID = useAppSelector((state) => state.yatPage.editStates.editingLiquidID);

    const containerRef = useRef<HTMLUListElement>(null);
    const thumbnailsIdsRef = useRef(Array.from({ length: LIQUID_ID_FACES_LENGTH }, (_, i) => `${i}`));
    const [buttonsActionable, setButtonsActionable] = useState(true);

    useTopic(glShowUIButtons, (d) => {
        setButtonsActionable(d);
    });

    return (
        <LiquidIDThumbnailsWrapper className={className}>
            <ThumbnailsList ref={containerRef} $editing={editingLiquidID}>
                {FACE_NAMES.map((face, index) => {
                    const item = liquidIDItems?.[index];
                    const formattedId = formatId(thumbnailsIdsRef.current[index]);

                    if (!item) {
                        return <Fragment key={index} />;
                    }

                    return (
                        <OuterThumbnailWrapper key={thumbnailsIdsRef.current[index]}>
                            <ThumbnailWrapper
                                id={formattedId}
                                data-index={index}
                                $draggable={editingLiquidID}
                                data-targetable="true"
                                className={LIQUID_ID_THUMBNAIL_WRAPPER_CLASS_NAME}
                            >
                                <>
                                    <Thumbnail
                                        removeFace={removeFace}
                                        onThumbnailClick={onClick}
                                        liquidIDFaceSelection={liquidIDFaceSelection}
                                        item={item}
                                        face={face}
                                        index={index}
                                        enabled
                                        canAction={buttonsActionable}
                                    />
                                </>
                            </ThumbnailWrapper>
                        </OuterThumbnailWrapper>
                    );
                })}
            </ThumbnailsList>
        </LiquidIDThumbnailsWrapper>
    );
};

export default LiquidIDThumbnails;
